import { render } from "./coursewareUploadVideo.vue?vue&type=template&id=11998b5a&scoped=true"
import script from "./coursewareUploadVideo.vue?vue&type=script&lang=js"
export * from "./coursewareUploadVideo.vue?vue&type=script&lang=js"

import "./coursewareUploadVideo.vue?vue&type=style&index=0&id=11998b5a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11998b5a"]])

export default __exports__